import styled from 'styled-components'

import CheetahIcon, { CheetahIconPack } from '@/components/atomic/atoms/CheetahIcon'

export interface Props {
  helpfulCount: number
  commentCount: number
  viewCount: number
}

const CommunityStatsBar = ({ helpfulCount, commentCount, viewCount }: Props): JSX.Element => {
  return (
    <StyledCommunityStatsBar>
      <StyledStat>
        <CheetahIcon name={CheetahIconPack.THUMB_UP} />
        <span aria-label="like count">{helpfulCount.toLocaleString()}</span>
      </StyledStat>
      <StyledStat>
        <CheetahIcon name={CheetahIconPack.COMMENT} />
        <span aria-label="reply count">{commentCount.toLocaleString()}</span>
      </StyledStat>
      <StyledStat>
        <CheetahIcon name={CheetahIconPack.VIEWS} />
        <span aria-label="view count">{viewCount.toLocaleString()}</span>
      </StyledStat>
    </StyledCommunityStatsBar>
  )
}

const StyledCommunityStatsBar = styled.div`
  ${({ theme }) => theme.typography.caption1};
  color: ${({ theme }) => theme.colors.gray800};
`

const StyledStat = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  &:after {
    content: '·';
    margin: 0px 4px;
  }
  &:last-child:after {
    content: '';
    margin: 0px;
  }
`

export default CommunityStatsBar
